import { Api, Http, DashboardByPortfolio } from '../../../models/index';
import { GetApi } from '../api/index';
import { CacheableResource } from '../CacheableResource';
import { GetResource } from '../GetResource';

export class GetPortfolioDashboards extends CacheableResource<
    CacheableResource.Params,
    DashboardByPortfolio[]
> {
    private getApi: GetApi;
    private getResource: GetResource<Api.Rel, DashboardByPortfolio[]>;

    constructor(http: Http) {
        super() /* istanbul ignore next */;
        this.getApi = new GetApi(http);
        this.getResource = new GetResource<Api.Rel, DashboardByPortfolio[]>(http);
    }

    protected doExecute(): Promise<DashboardByPortfolio[]> {
        return this.getApi.execute().then((api) => {
            return this.getResource
                .execute({
                    parent: api,
                    rel: 'portfolio-dashboards'
                })
                .then((dashboard) => dashboard!);
        });
    }
}
